/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Aria_LabelInputs */

const en_position_aria_label = /** @type {(inputs: Position_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Position`)
};

const fr_position_aria_label = /** @type {(inputs: Position_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position de l'Evenement`)
};

const de_position_aria_label = /** @type {(inputs: Position_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsposition`)
};

const it_position_aria_label = /** @type {(inputs: Position_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione dell'evento`)
};

const ru_position_aria_label = /** @type {(inputs: Position_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция события`)
};

const es_position_aria_label = /** @type {(inputs: Position_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición del evento`)
};

const zh_cn2_position_aria_label = /** @type {(inputs: Position_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件位置`)
};

const ja_position_aria_label = /** @type {(inputs: Position_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントポジション`)
};

const hi_position_aria_label = /** @type {(inputs: Position_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना की स्थिति`)
};

const pt_pt2_position_aria_label = /** @type {(inputs: Position_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição do evento`)
};

/**
* | output |
* | --- |
* | "Event Position" |
*
* @param {Position_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_aria_label = /** @type {((inputs?: Position_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_aria_label(inputs)
	if (locale === "de") return de_position_aria_label(inputs)
	if (locale === "it") return it_position_aria_label(inputs)
	if (locale === "ru") return ru_position_aria_label(inputs)
	if (locale === "es") return es_position_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_position_aria_label(inputs)
	if (locale === "ja") return ja_position_aria_label(inputs)
	if (locale === "hi") return hi_position_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_position_aria_label(inputs)
	return en_position_aria_label(inputs)
});